import { defineComponent as t, ref as r, onMounted as a, createBlock as n, createCommentVNode as l, openBlock as d, Teleport as f, renderSlot as u } from "vue";
const c = /* @__PURE__ */ t({
  name: "RevPortal",
  __name: "Portal",
  props: {
    to: { default: "body" },
    defer: { type: Boolean, default: !1 }
  },
  setup(p) {
    const o = r(!1);
    return a(() => {
      o.value = !0;
    }), (e, s) => o.value ? (d(), n(f, {
      key: 0,
      defer: e.defer,
      to: e.to
    }, [
      u(e.$slots, "default")
    ], 8, ["defer", "to"])) : l("", !0);
  }
});
export {
  c as default
};
